import { render, staticRenderFns } from "./topArticleBox.vue?vue&type=template&id=71fda800&"
import script from "./topArticleBox.vue?vue&type=script&lang=js&"
export * from "./topArticleBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports